import { render } from "./FormGeneralSettings.vue?vue&type=template&id=65bc989c&scoped=true"
import script from "./FormGeneralSettings.vue?vue&type=script&lang=js"
export * from "./FormGeneralSettings.vue?vue&type=script&lang=js"

import "./FormGeneralSettings.vue?vue&type=style&index=0&id=65bc989c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-65bc989c"

export default script